export function isNamedElementActive(name: string) {
    const elements = document.getElementsByName(name);
    const elementArray = Array.from(elements);
    const indexActiveElement = elementArray.findIndex((el) => el === document.activeElement);
    return (indexActiveElement >= 0);
}